export default __webpack_public_path__ + "static/media/3c4f5766e6f2d1ea5e45ed6909871f73.svg";